import { Card, CardContent } from "../../components/ui/card";
import { formatEuro, MargineBadge, crownRank } from "../../pages/menu/menuHelpers";

const MenuTop3Card = ({ top3, categorie, onSelect }) => {
  if (top3.length === 0) return null;

  return (
    <Card className="bg-gradient-to-br from-amber-50 via-white to-yellow-50 border-amber-200" data-testid="top3-margine-card">
      <CardContent className="p-4 sm:p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="text-2xl">👑</div>
          <div className="flex-1 min-w-0">
            <h3 className="font-bold text-gray-900">Top 3 piatti per redditività</h3>
            <p className="text-xs text-amber-700/80 mt-0.5">
              Margine più alto = più profitto per ogni vendita. Spingi questi al cliente indeciso.
            </p>
          </div>
        </div>
        <div className="space-y-2">
          {top3.map((p, idx) => {
            const cat = categorie.find((c) => c.id === p.categoria_id);
            const moltiplicatore =
              (p.totale_live ?? p.food_cost_live ?? p.food_cost) > 0 ? (p.prezzo_vendita / (p.totale_live ?? p.food_cost_live ?? p.food_cost)).toFixed(1) : null;
            return (
              <button
                key={p.id}
                type="button"
                onClick={() => onSelect(p)}
                className="w-full flex items-center gap-3 p-2.5 rounded-xl bg-white/70 hover:bg-white border border-amber-100 transition-colors text-left"
                data-testid={`top3-piatto-${p.id}`}
              >
                <span className="text-2xl shrink-0 w-8 text-center">{crownRank(idx + 1)}</span>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-gray-900 truncate">{p.nome}</p>
                  <p className="text-xs text-gray-500 truncate">
                    {cat ? `${cat.icona || "🍽️"} ${cat.nome} • ` : ""}
                    {formatEuro(p.prezzo_vendita)} • food cost {formatEuro(p.totale_live ?? p.food_cost_live ?? p.food_cost)}
                    {moltiplicatore ? ` • ×${moltiplicatore}` : ""}
                  </p>
                </div>
                <div className="text-right shrink-0">
                  <MargineBadge margine={p._margine} />
                </div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default MenuTop3Card;
